import React from 'react'
import { withIdentity, WithIdentityProps } from '#src/containers/Identity'
import {
  BusinessUserChatWidgetComponent,
  StartExpertConsumerConversationComponent
} from '#src/generated/graphql'
import ChatWidget from '#src/containers/ChatWidget'

interface BusinessUserChatWidgetProps {
  businessUserId: string
  className?: string
}

const BusinessUserChatWidget: React.SFC<BusinessUserChatWidgetProps & WithIdentityProps> = ({
  myself,
  businessUserId,
  className
}) => {
  if (process.env.TARGET === 'node') {
    return null
  }

  if (!myself) {
    return null
  }

  return (
    <BusinessUserChatWidgetComponent variables={{ id: businessUserId }}>
      {({ data }) => {
        if (!data || !data.businessUser) {
          return null
        }

        // The recommended expert to talk to for this category
        const expert = data.businessUser
        const existingConversationId =
          expert &&
          expert.existingLeadForConsumer &&
          expert.existingLeadForConsumer.conversation &&
          expert.existingLeadForConsumer.conversation.externalId

        if (!expert) {
          return null
        }

        return (
          <StartExpertConsumerConversationComponent
            variables={{
              input: { consumerId: myself.id, expertId: expert.id }
            }}
          >
            {(startExpertCustomerConversation, { data }) => {
              const conversationId =
                existingConversationId ||
                (data &&
                  data.startExpertConsumerConversation.conversation &&
                  data.startExpertConsumerConversation.conversation.externalId)

              return (
                <ChatWidget
                  businessUserId={expert.id}
                  className={className}
                  conversationId={conversationId}
                  expert={expert}
                  onStartConversation={() => {
                    startExpertCustomerConversation()
                  }}
                />
              )
            }}
          </StartExpertConsumerConversationComponent>
        )
      }}
    </BusinessUserChatWidgetComponent>
  )
}

export default withIdentity(BusinessUserChatWidget)
